/*
 *
 * ActionPlans actions
 *
 */

import {
  DEFAULT_ACTION,
  FILTERS_FAILED,
  FILTERS_SUCCESS,
  FILTERS_WATCHER,
  GET_PLANS_FAILED,
  GET_PLANS_SUCCESS,
  GET_PLANS_WATCHER,
  GET_TEMPLATE_WATCHER,
  GET_TEMPLATE_SUCCESS,
  GET_TEMPLATE_FAILED,
  GET_TEMPLATE_TASK_WATCHER,
  GET_TEMPLATE_TASK_SUCCESS,
  GET_TEMPLATE_TASK_FAILED,
  GET_SURVEYS_WATCHER,
  GET_SURVEYS_FAILED,
  GET_SURVEYS_SUCCESS,
} from "./constants"

export function defaultAction() {
  return { type: DEFAULT_ACTION }
}

export function filtersWatcher(payload) {
  return {
    type: FILTERS_WATCHER,
    payload,
  }
}

export function filtersSuccess(payload) {
  return {
    type: FILTERS_SUCCESS,
    payload,
  }
}

export function filtersFailed() {
  return { type: FILTERS_FAILED }
}

export function getPlansWatcher(payload) {
  return {
    type: GET_PLANS_WATCHER,
    payload,
  }
}

export function getPlansSuccess(payload) {
  return {
    type: GET_PLANS_SUCCESS,
    payload,
  }
}

export function getPlansFailed() {
  return { type: GET_PLANS_FAILED }
}

// GET TEMPLATE
export function getTemplate(payload) {
  return {
    type: GET_TEMPLATE_WATCHER,
    payload,
  }
}

export function getTemplateSuccess(payload) {
  return {
    type: GET_TEMPLATE_SUCCESS,
    payload,
  }
}

export function getTemplateFailed(payload) {
  return { type: GET_TEMPLATE_FAILED }
}

// GET TEMPLATE TASK
export function getTemplateTask(payload) {
  return {
    type: GET_TEMPLATE_TASK_WATCHER,
    payload,
  }
}

export function getTemplateTaskSuccess(payload) {
  return {
    type: GET_TEMPLATE_TASK_SUCCESS,
    payload,
  }
}

export function getTemplateTaskFailed() {
  return { type: GET_TEMPLATE_TASK_FAILED }
}

// GET SURVEY
export function getSurveys(payload) {
  return {
    type: GET_SURVEYS_WATCHER,
    payload,
  }
}

export function getSurveysSuccess(payload) {
  return {
    type: GET_SURVEYS_SUCCESS,
    payload,
  }
}

export function getSurveysFailed(payload) {
  return {
    type: GET_SURVEYS_FAILED,
    payload,
  }
}
